import "./i18n";

import { AuthApi } from "api/auth";
import { ResponseEnum } from "enums/response";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useIP } from "hooks/useIP";
import { useLogout } from "hooks/useLogout";
import { useEffect, useRef } from "react";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { Outlet } from "react-router-dom";
import { selectIsAuthenticated, selectToken, selectUsername } from "store/auth";
import { verifyToken } from "store/auth/auth.thunk";
import { selectURLWhatsApp } from "store/contact";
import { getContactUs } from "store/contact/contact.thunk";
import { getVipMember } from "store/member/member.thunk";
import { fetchLogo } from "store/retrieve/retrieve.thunk";
import { getMemberBalance, getProfile } from "store/user/user.thunk";
import { ThemeProvider } from "styled-components";
import { GlobalStyle } from "styles/global";
import { theme } from "styles/theme";

function App() {
  const dispatch = useAppDispatch();

  const URLWhatsApp = useAppSelector(selectURLWhatsApp);

  const isAuth = useAppSelector(selectIsAuthenticated);
  const token = useAppSelector(selectToken) || localStorage.getItem("token");
  const username =
    useAppSelector(selectUsername) || localStorage.getItem("username");

  const appRef = useRef<NodeJS.Timeout | undefined>(undefined);

  const logout = useLogout();

  useIP();

  useEffect(() => {
    dispatch(getContactUs());
    dispatch(fetchLogo());
  }, []);

  useEffect(() => {
    if (!username) return;
    if (!token) return;

    const fetchProfile = async () => {
      try {
        const responseVerify = await dispatch(verifyToken({ username, token }));

        if (!responseVerify.payload) return;

        dispatch(
          getMemberBalance({
            username,
          })
        );

        dispatch(getProfile(username));
        dispatch(getVipMember({ username }));
      } catch (error) {
        //
      }
    };

    fetchProfile();
  }, [username]);

  useEffect(() => {
    if (isAuth) {
      appRef.current = setInterval(fetchVerifyToken, 15 * 1000);
    } else {
      clearInterval(appRef.current);
    }
  }, [isAuth]);

  const fetchVerifyToken = async () => {
    if (!username) return;
    if (!token) return;
    try {
      const response = await AuthApi.verifyToken(username, {
        username: username,
        token: token,
      });

      if (response.status !== ResponseEnum.statusSuccess) {
        logout();
        return;
      }
    } catch (error) {}
  };

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <FloatingWhatsApp
        phoneNumber={URLWhatsApp}
        accountName={"RRRBets Support"}
        allowEsc
        allowClickAway
        notification
        notificationSound
      />
      <div className="App">
        <Outlet />
      </div>
    </ThemeProvider>
  );
}
export default App;
